var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButtonRectangle',[_c('BaseText6',{attrs:{"text":"Continue as guest"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }